// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1OAuthRevokeRequestSchema } from './v1/oAuth/revokeRequestSchema';

/**
 * @description token revoked
 */
export const revokeAccessToken200Schema = z.unknown();

export const revokeAccessTokenMutationRequestSchema = z.lazy(() => v1OAuthRevokeRequestSchema);

export const revokeAccessTokenMutationResponseSchema = z.lazy(() => revokeAccessToken200Schema);
